/*
 * File: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice\src\Content\Modals\ModalAddCar\ModalAddCar.tsx
 * Project: c:\Users\j.mazat\Desktop\Autofi\autofi_backoffice
 * Created Date: Monday March 18th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 18th 2024 5:51:33 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { MouseEventHandler, useRef, useState } from "react";
import {Form, Button} from "react-bootstrap";
import MyModal from "Content/Modals/MyModal";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Modals/ModalUser/ModalUser.module.css";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import CarService from "Services/Car/CarService";
import CarTemplateForm from "Content/Car/CarTemplateForm/CarTemplateForm";
import { Input } from "@mui/material";
import { TemplateCarDataType } from "Type/Car.type";
import { PriceListRefType } from "Type/pricing.type";
import Config from "Config/Config";
import PriceList from "Content/Pricing/PriceList/priceList";
import { CarEquipment } from "Content/Equipment/CarEquipment";
import { UpdateCarType } from "Type/CarElement.type.hold";

type ModalProps = {
    show: boolean,
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    title: string,
};

function ModalAddCar(props: ModalProps) {
    const [isSendable, setIsSendable] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [files, setFiles] = useState<FileList>();
    const [additionnalText, setAdditionnalText] = useState<string | string[] | undefined>();

    const loaRef = useRef<PriceListRefType>({});
    const lldRef = useRef<PriceListRefType>({});
    const carData = useRef<TemplateCarDataType>();
    const updateData = useRef<UpdateCarType>({update: {}, create: {}, delete: {}});

    const HandleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setSpinner(true);
        if (files && carData.current && (loaRef.current || lldRef.current)) {
            CarService.addNewCars(files, carData.current, loaRef.current, lldRef.current, updateData.current.create.EquipmentsToCreate).then(res => {
                if (res.data.errors && res.data.errors.length > 0)
                    setAdditionnalText(["Une erreur est survenue:", ...res.data.data.errors]);
                setIsOkay(true);
                setOpenModal(true);
                setSpinner(false);
            }).catch((error) => {
                console.log(error);
                setIsOkay(false);
                setOpenModal(true);
                setSpinner(false);
            });
        } else
            setIsSendable(false);
    };

    const checkIsSendable = () => {
        new Promise(r => setTimeout(r, 500)).then(() => {
            if ((Object.values(loaRef.current).length > 0 || Object.values(lldRef.current).length > 0) && carData.current && Object.entries(carData.current).every(x => x[1]) && files && files.length > 0)
                setIsSendable(true);
            else
                setIsSendable(false);
        });
    };

    function setFilePicking(e: any) {
        if (e.target.files.length > 0) {
            setFiles(e.target.files);
            checkIsSendable();
        } else {
            setFiles(undefined);
            setIsSendable(false);
        }
    };

    return(
        <>
            <MyModal closeModal={props.closeModal} show={props.show} addCloseCross={true} onClose={props.onClose} footer={(() => { return (<Button disabled={!isSendable} onClick={(e) => {HandleSubmit(e)}}>{translator.decode("dynamic.create")}</Button>); })()} title={props.title} className={`${Styles.myModal}`}>
                {
                    spinner ?
                    <div className={`${Styles.spinnerHolder}`}>
                            <LoadingScreen />
                        </div>
                        :null
                }
                <Form className={`${Styles.formHolder}`}>
                    <Input type="file" inputProps={{multiple: true, accept: "image/jpeg, image/jpg, image/png"}} onChange={setFilePicking} />
                    <CarTemplateForm ref={carData} cb={checkIsSendable} />
                    <PriceList editable={true} priceType="LOA" title={translator.decode("table.headers.Loa")} ref={loaRef} defaultMonth={Config.COMMON.LOA_MONTH} defaultMileage={Config.COMMON.LOA_MILEAGE} cb={checkIsSendable} />
                    <PriceList editable={true} priceType="LLD" title={translator.decode("table.headers.Lld")} ref={lldRef} defaultMonth={Config.COMMON.LLD_MONTH} defaultMileage={Config.COMMON.LLD_MILEAGE} cb={checkIsSendable} />
                    <CarEquipment carUpdate={updateData.current} disabled={false} id={""} />
                </Form>
            </MyModal>
            <ModalConfirmation show={openModal} onClose={() => setOpenModal(false)} closeModal={() => setOpenModal(false)} isOkay={isOkay} additionnalMessage={additionnalText}/>
        </>
    )
}

export default ModalAddCar;
